import { render, staticRenderFns } from "./wtr-slide-card.vue?vue&type=template&id=045aa090&scoped=true&"
import script from "./wtr-slide-card.vue?vue&type=script&lang=js&"
export * from "./wtr-slide-card.vue?vue&type=script&lang=js&"
import style0 from "./wtr-slide-card.vue?vue&type=style&index=0&id=045aa090&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045aa090",
  null
  
)

export default component.exports